import headerNavigation from '../../navigation/header.js';

new headerNavigation(document.querySelector('[data-comp-header-navigation]'));
